import React, { useState, useRef, useEffect } from 'react';
import { Grid, Input, Button, withTheme } from '@material-ui/core';
import FancySelectButton from '../fancy/FancySelectButton';
import { UsersIcon } from '../../icons';

function GolfGroupInput({
    currentNumber,
    onChangeNumber,
    theme,
    largeGroupStart,
    largeGroupLimit,
    label
}) {
    const [inEditMode, setEditMode] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [inEditMode, inputRef]);

    return (
        <>
            {!inEditMode && currentNumber < largeGroupStart && (
                <Grid item xs={12} container justifyContent="center">
                    <Button
                        variant="contained"
                        className="btn-golf-rounded wide-button white"
                        onClick={() => setEditMode(true)}
                        style={{ color: theme.palette.primary.main }}
                    >
                        Larger Groups
                    </Button>
                </Grid>
            )}
            {!inEditMode && currentNumber >= largeGroupStart && (
                <Grid container justifyContent="center">
                    <FancySelectButton fullWidth highlight>
                        <UsersIcon style={{ color: 'white' }} />
                        &nbsp;
                        <span style={{ color: 'white' }}>
                            {currentNumber} {label}
                        </span>
                    </FancySelectButton>
                    <Button onClick={() => setEditMode(true)}>Change</Button>
                </Grid>
            )}
            {inEditMode && (
                <form
                    id="large-group-form"
                    onSubmit={e => {
                        e.preventDefault();
                        onChangeNumber(
                            Math.min(Math.max(+inputRef.current.value, 0), largeGroupLimit)
                        );
                        setEditMode(false);
                    }}
                >
                    <Grid container alignItems="center" justifyContent="center" spacing={1}>
                        <Grid item>
                            <Input
                                inputRef={inputRef}
                                type="number"
                                placeholder={`Up to ${largeGroupLimit} ${label}`}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item>
                            <FancySelectButton
                                type="submit"
                                form="large-group-form"
                                label="Submit"
                            />
                        </Grid>
                    </Grid>
                </form>
            )}
        </>
    );
}

export default withTheme(GolfGroupInput);
